import React from "@platform/react";
import { Component } from "@platform/react-storybook/Component";

import { Text } from "@front/components/Element/Text";
import { BitmapAsset } from "@front/components/Element/Asset/Bitmap";
import { Button } from "@front/components/Element/Button";

import "./_rules.module.scss";
import { DEF_BECOME, NAME_BECOME, TYPE_BECOME } from "./types";
import type { PropTypesBecome } from "./types";

export function SectionBecome(props: PropTypesBecome) {
    const { onClick, ...rest } = props;
    return (
        <Component {...rest} name={NAME_BECOME} tag="div" type={TYPE_BECOME}>
            <header>
                <Text preset="torreon" uuid="title-programs" />
            </header>
            <footer>
                <BitmapAsset uuid="screenshot-programs" />
                <Text raw preset="puebla" uuid="programs-mixin" />
                <Button preset="nigeria" text="button-ready" onClick={onClick} />
            </footer>
        </Component>
    );
}
SectionBecome.defaultProps = DEF_BECOME;
